import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { resetPassword as apiResetPassword } from "../api/api.js";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(""); // 'success' o 'error'

  const token = searchParams.get("token");
  const id = searchParams.get("id");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    
    if (!token || !id) {
      setMessage("Link non valido o incompleto.");
      setStatus("error");
      return;
    }

    try {
      const response = await apiResetPassword({ 
        token, 
        id, 
        new_password: newPassword 
      });

      if (response.ok) {
        setStatus("success");
        setMessage("Password aggiornata con successo! Verrai reindirizzato al login...");
        setTimeout(() => navigate("/"), 3000);
      } else {
        setStatus("error");
        setMessage(response.error || "Errore durante il reset della password.");
      }
    } catch (err) {
      setStatus("error");
      setMessage("Errore di rete. Riprova più tardi.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-sm p-4" style={{ width: "90%", maxWidth: "400px" }}>
        <h3 className="text-center mb-4">Nuova Password</h3>
        <p className="text-muted text-center small">Inserisci la tua nuova password sicura.</p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Minimo 6 caratteri"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Reimposta Password
          </button>
        </form>

        {message && (
          <div className={`alert mt-3 ${status === "success" ? "alert-success" : "alert-danger"}`} role="alert">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}